<template>
    <div>
    <div class="container-fluid right_wrapper">
        <DefineGuardrailHeader></DefineGuardrailHeader>
        <DefineNewGuardrailForm class="table_wrap no_footer pt-2"></DefineNewGuardrailForm>
      </div>
    </div>
</template>

<script>
import DefineGuardrailHeader from '@/components/define-guardrail/DefineGuardrailHeader.vue'
import DefineNewGuardrailForm from '@/components/define-guardrail/DefineNewGuardrailForm.vue'

export default {
    components: {
        DefineGuardrailHeader,
		DefineNewGuardrailForm
    }
}
</script>

<style lang="scss">

</style>
